import React, { Component } from 'react'
import { dateFormatter, formatDecimal } from 'utils/formatter'

class RedeemHistoryRow extends Component {

  render () {
    let {redemption} = this.props
    return (
      <tr onClick={this._onClickRow}>
        <td className='col-md-3'>{dateFormatter(redemption.created_at)}</td>
        <td className='col-md-7'>{redemption.reward}</td>
        <td className='col-md-2 text-right'>{formatDecimal(redemption.redeem_points)}</td>
      </tr>
    )
  }

  _onClickRow = () => {
    let {redemption} = this.props
    this.props.onClickRow({
      payment_type: redemption.payment_type.toLowerCase(),
      parent_payment_id: redemption.parent_payment_id
    })
  }
}

RedeemHistoryRow.propTypes = {
  onClickRow: React.PropTypes.func
}

export default RedeemHistoryRow



// WEBPACK FOOTER //
// ./app/pages/Customers/CustomerList/ListLoyalty/CustomerDetail/RedeemHistoryRow.js